// @ts-nocheck
import { useTranslation } from 'react-i18next'
import { useParams } from 'react-router'
import { useQuery } from '@apollo/client/react'

import EntityAddEditForm from 'js/components/EntityActions/EntityAddEditForm'

import getRefetchQueries from '../helpers/getRefetchQueries'

import { Query } from './Add.queries'

export const EventAddPage = () => {
    const { t } = useTranslation()
    const { groupGuid, containerGuid } = useParams()

    const { data, loading } = useQuery(Query, {
        variables: {
            guid: containerGuid,
        },
        skip: !containerGuid,
    })

    if (loading && !data) {
        return null
    }

    const refetchQueries = getRefetchQueries(false, !!groupGuid)

    const addTitle = containerGuid
        ? 'entity-event.create-activity'
        : 'entity-event.create'

    return (
        <EntityAddEditForm
            title={t(addTitle)}
            subtype="event"
            isSubEvent={!!containerGuid}
            defaultStartDate={data?.entity?.startDate}
            refetchQueries={refetchQueries}
        />
    )
}
